export default __webpack_public_path__ + "static/media/support-icon.214c3d73.svg";